import { useState } from 'react';
import { startImpersonation } from '@halo/web-lib';

interface Props {
  storeId: number;
  storeName: string;
  onClose: () => void;
  onStarted: () => void;
}

export function ImpersonateConfirmModal({ storeId, storeName, onClose, onStarted }: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function confirm() {
    setLoading(true);
    setError(null);
    try {
      await startImpersonation(storeId);
      onStarted();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to start session');
      setLoading(false);
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="impersonate-modal-title"
    >
      <div className="w-[480px] rounded-lg bg-white dark:bg-gray-900 p-6 shadow-xl">
        <h2 id="impersonate-modal-title" className="text-lg font-semibold">
          Impersonate store
        </h2>
        <p className="mt-3 text-sm text-gray-700 dark:text-gray-200">
          You're about to enter <strong>{storeName}</strong> as OWNER. You'll start in
          read-only mode. Sessions last up to 4 hours. This will be logged.
        </p>
        {error && (
          <p className="mt-2 text-sm text-red-600 dark:text-red-400" role="alert">
            {error}
          </p>
        )}
        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="rounded border border-gray-300 dark:border-gray-700 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-950 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={confirm}
            disabled={loading}
            className="rounded bg-amber-600 px-4 py-2 text-sm font-medium text-white hover:bg-amber-700 disabled:opacity-50"
          >
            {loading ? 'Starting…' : 'Start read-only session'}
          </button>
        </div>
      </div>
    </div>
  );
}
